<div class="main" *ngIf="experiencias && experiencias.length > 0">
    <h3 class="heading">Histórico de experiência</h3>

    <div class="container">

        <ul>
            <li *ngFor="let experiencia of experiencias">
                <div class="row mb-3">
                    <h3 class="title col-10">{{experiencia.titulo}}</h3>
                    <div *ngIf="exibirLixo" class="col-2" style=" text-align: right;">
                        <div>
                            <span (click)="delete(experiencia)"
                                class="btn btn-icon btn-circle  w-25px h-25px bg-body shadow">
                                <img src="../../../../assets/img/para_candidatos/lixeira-experiencia.svg" alt="lixeira">
                            </span>
                        </div>
                    </div>
                </div>

                <mat-divider></mat-divider>

                <p class="localizacao mt-3"> {{experiencia.dataFim ? "Trabalhou" : "Trabalha"}} na
                    {{experiencia.nomeEmpresa}}
                    localizada em {{experiencia.cidade}} - {{experiencia.uf}}
                </p>

                <div class="rounded mt-5">
                    <div class="descricao">
                        {{experiencia.descricao}}
                    </div>
                </div>

                <mat-divider class="mt-5"></mat-divider>

                <div class="row datas-experiencias mt-5">
                    <div class="col-1">
                        <img src="../../../../assets/img/para_candidatos/calendario-experiencia.svg" alt="">
                    </div>
                    <div class="col-11 datas-experiencias align-content-center">
                        <p *ngIf="experiencia.trabalhaAtualmente && (!experiencia.dataFim || experiencia.dataFim == undefined)">
                            Início: {{ experiencia.dataInicio ? (experiencia.dataInicio | date: 'dd/MM/yyyy') : 'Indeterminado' }}
                            e segue até a data atual
                        </p>

                        <p *ngIf="!experiencia.trabalhaAtualmente && (!experiencia.dataFim || experiencia.dataFim == undefined)">
                            Início: {{ experiencia.dataInicio ? (experiencia.dataInicio | date: 'dd/MM/yyyy') : 'Indeterminado' }} -
                            Término: indeterminado
                        </p>

                        <span class="circle"></span>

                        <span *ngIf="experiencia.dataFim" class="date">
                            Início: {{ experiencia.dataInicio ? (experiencia.dataInicio | date: 'dd/MM/yyyy') : 'Indeterminado' }} -
                            Término: {{ experiencia.dataFim | date: 'dd/MM/yyyy' }}
                        </span>
                    </div>
                </div>

            </li>

        </ul>

    </div>
</div>
